import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false,
})
export class SafeHtml {
    constructor(private sanitizer: DomSanitizer) {}

    transform(style) {
        //        return this.sanitizer.bypassSecurityTrustStyle(style);
        return this.sanitizer.bypassSecurityTrustHtml(style);
        // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
    }
}
